import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Loader from "../../../../components/loader";
import AdminLayout from "../../../../layouts/AdminLayout";
import Wellness from "../../../../components/pages/comman/nuvio-wellness";

const EditNuterraDetails = () => {
  const data = useLocation()?.state?.data;
  const { isLoading } = useSelector((state) => state.admin.auth);
  if (isLoading) {
    return <Loader />;
  }
  return (
    <AdminLayout>
      <Wellness contentEditable={true} data={data} />
    </AdminLayout>
  );
};

export default EditNuterraDetails;
